import DialogTutorial1 from '~/components/dialog/tutorial/DialogTutorial1.vue';
import DialogTutorial2 from '~/components/dialog/tutorial/DialogTutorial2.vue';
import DialogTutorial3 from '~/components/dialog/tutorial/DialogTutorial3.vue';
import DialogTutorial4 from '~/components/dialog/tutorial/DialogTutorial4.vue';
import DialogTutorial5 from '~/components/dialog/tutorial/DialogTutorial5.vue';

export const useDialogTutorial = () => {
  const completeEvent = createEventHook<any>();

  const dialog = useDialogStore();

  const step = ref(0);

  const dialogs = [
    DialogTutorial1,
    DialogTutorial2,
    DialogTutorial3,
    DialogTutorial4,
    DialogTutorial5,
  ];

  const next = async () => {
    await dialog.close();
    step.value += 1;
    if (step.value === dialogs.length) {
      completeEvent.trigger();
      return;
    }

    open();
  };

  const open = () => {
    dialog.open(dialogs[step.value], {
      level: DialogLevel.Info,
      onNext: () => next(),
    });
  };

  const start = () => {
    step.value = 0;
    open();
  };

  return {
    start,
    onComplete: completeEvent.on,
  };
};
